import { Fieldset } from '../../../../controller/services/comments-service';
export const getPageFieldsets = (options) => [
    Fieldset.MEMBERS,
    Fieldset.REACTIONS,
    Fieldset.MEMBER_BADGES,
    Fieldset.MEMBER_ROLES,
    ...(options.withVotes ? [Fieldset.VOTES] : []),
    ...(options.withRatings ? [Fieldset.RATINGS_SUMMARY, Fieldset.CURRENT_RATING] : []),
];
export const getInitialFieldsets = (options) => {
    const defaultFields = [
        Fieldset.MEMBERS,
        Fieldset.REGISTRATION_DATA,
        Fieldset.MEMBER_BADGES,
        Fieldset.MEMBER_ROLES,
        Fieldset.TOTAL_COMMENTS,
        Fieldset.CONTEXT_PERMISSIONS,
        Fieldset.CURRENT_MEMBER,
        Fieldset.FOLLOWED_MEMBERS,
        ...(options.withRatings ? [Fieldset.RATINGS_SUMMARY] : []),
    ];
    return options.fetchMode === 'comments_only'
        ? defaultFields
        : [
            ...defaultFields,
            Fieldset.REACTIONS,
            ...(options.withVotes ? [Fieldset.VOTES] : []),
            ...(options.withRatings ? [Fieldset.CURRENT_RATING] : []),
        ];
};
//# sourceMappingURL=comment-request-utils.js.map